<div class="component-wrapper">
  <mojo-dashboard-filters
    (changeJobStatusFilter)="changeJobStatusFilter($event)"
    (functionAndDepartmentsFilters)="changeFunctionAndDepartment($event)"
  >
  </mojo-dashboard-filters>
</div>

<div class="component-wrapper">
  <div class="details-wrapper">
    <div>Overview</div>
  </div>
  <mojo-dashboard-bar-charts></mojo-dashboard-bar-charts>
</div>

<div class="component-wrapper">
  <div class="details-wrapper">
    <div>Details</div>
    <mojo-reports-jobs-search-widget
      [selectedFunction]="mapFunctionOrDepartment(false)"
      [selectedDepartment]="mapFunctionOrDepartment(true)"
      [jobStatus]="params.status"
      (sendCandidateOrHiringManagerName)="changeCandidateOrHiringManager($event)"
    >
    </mojo-reports-jobs-search-widget>
  </div>
  <mojo-dashboard-averages></mojo-dashboard-averages>
</div>

<div class="component-wrapper">
  <mojo-dashboard-jobs-list
    (reloadList)="pageChange($event)"
    [allJobs]="selectAllJobs$ | async"
  >
  </mojo-dashboard-jobs-list>
</div>
